import { multiRoomRateAddToBasket, roomRateAddToBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import React from 'react';
import { connect } from 'react-redux';
import { RoomRateConfigurationWizardV2 } from './RoomRateConfigurationWizardV2';
import {
  RoomRateConfigurationWizardV2DispatchProps,
  RoomRateConfigurationWizardV2OwnProps,
  RoomRateConfigurationWizardV2StoreProps,
} from './RoomRateFormV2.types';

const mapStateToProps = (state): RoomRateConfigurationWizardV2StoreProps => ({
  basketGuests: basketSelectors.getBasketGuests(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  isFetching: basketSelectors.getIsBasketDetailsFetching(state),
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  loggedGuest: guestSelectors.getGuest(state),
});

const mapDispatchToProps = (dispatch): RoomRateConfigurationWizardV2DispatchProps => ({
  roomRateAddToBasket: roomRateAddToBasket(dispatch),
  multiRoomRateAddToBasket: multiRoomRateAddToBasket(dispatch),
});

export const RoomRateConfigurationWizardV2Connected: React.ComponentType<RoomRateConfigurationWizardV2OwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(RoomRateConfigurationWizardV2);
